import IntroSection from './intro-section';
import AboutSection from './about-section';
import SkillsSection from './skills-section';
import CareerSection from './career-section';
import PortfolioSection from './portfolio-section';
import ContactSection from './contact-section';

import Navigation from './navigation';
import { ActiveSectionContextProvider } from '../context/active-section-context';

const Layout = () => {
  return (
    <div className="main-wrapper">
      <ActiveSectionContextProvider value={{ activeSectionId: 'intro' }}>
        <Navigation />
        <main className="main">
          <IntroSection />
          <AboutSection />
          <SkillsSection />
          <CareerSection />
          <PortfolioSection />
          <ContactSection />
        </main>
      </ActiveSectionContextProvider>
    </div>
  );
};

export default Layout;
